import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=c59e86c0&scoped=true&"
import script from "./companies.vue?vue&type=script&lang=js&"
export * from "./companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e86c0",
  null
  
)

export default component.exports